import SaIcon from './SaIcon';

export default {
    install(Vue, option) {
        // const _option = [].concat(option);
        // _option.forEach(item => {
        //     if (item === 'common') {
        //         require('./assets/iconfont/common/iconfont/iconfont.css')
        //     }
        //     if (item === 'simba') {
        //         require('./assets/iconfont/dataSimbaNext/iconfont/iconfont.css')
        //     }
        //     if (item === 'nuza') {
        //         require('./assets/iconfont/nuza/iconfont/iconfont.css')
        //     }
        //     if (item === 'shelf') {
        //         require('./assets/iconfont/shelfSystem/iconfont/iconfont.css')
        //     }
        // })
        Vue.component(SaIcon.name, SaIcon);
    },
};
